import {
  CreditApplicationStatus,
  CreditApplicationStep,
  CreditProductName,
} from '@/types/customer-context'

const productLabels: Record<CreditProductName, string> = {
  allowance: 'Mesada',
  internship: 'Financiamento estudantil',
  personal_loan: 'Crédito para médicos',
}

export function creditProductLabel(product: CreditProductName) {
  return productLabels[product]
}

const stepGroup: Record<CreditApplicationStep, number> = {
  initial_proponents: 0,
  pre_analysis: 0,
  proponets_data: 0,
  proponets_documents: 1,
  committee_analysis: 2,
  documents_analysis: 2,
  proposal: 3,
  agreement_signature: 4,
  credit_note_signature: 4,
}

export const creditStepLabels = [
  'Cadastro',
  'Documentos',
  'Análise',
  'Proposta',
  'Contrato',
] as const

export function creditStepIndex(
  status: CreditApplicationStatus,
  step: CreditApplicationStep,
) {
  if (status === 'done') return creditStepLabels.length
  return stepGroup[step]
}

export function creditApplicationLabel(
  status: CreditApplicationStatus,
  step: CreditApplicationStep,
) {
  if (status === 'done') return 'Concluído'
  if (status === 'review') return 'Pendência para corrigir'
  if (status === 'analysing') return 'Em análise'
  if (step === 'proposal') return 'Proposta para aceitar'
  if (step === 'agreement_signature' || step === 'credit_note_signature') {
    return 'Assinatura pendente'
  }
  if (status === 'approved') return 'Contratação em andamento'
  if (status === 'incomplete') return 'Cadastro em andamento'
  return 'Em andamento'
}
